import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getSupplierTypeListSaga = createAction(
  "GET_SUPPLIER_TYPE",
  ({ payload, params }: SagaActionParams<Type.SupplierTypeDto[]>) => ({
    payload,
    url: "/api/admin/suppliertypes" + (params ? params : ""),
  })
);
export const getSupplierTypeDetailsSaga = createAction(
  "GET_SUPPLIER_TYPE_DETAILS",
  ({ payload, id }: SagaActionParams<Type.SupplierTypeDetailDto>) => ({
    payload,
    url: "/api/admin/suppliertypes/" + id,
  })
);
export const createSupplierTypeSaga = createAction(
  "CREATE_SUPPLIER_TYPE",
  ({ payload, body }: SagaActionParams<Type.SupplierTypeDto>) => ({
    payload,
    url: "/api/admin/suppliertypes",
    body,
  })
);
export const updateSupplierTypeSaga = createAction(
  "UPDATE_SUPPLIER_TYPE",
  ({ payload, id, body }: SagaActionParams<Type.SupplierTypeDto>) => ({
    payload,
    url: "/api/admin/suppliertypes/" + id,
    body,
  })
);
export const deleteSupplierTypeSaga = createAction(
  "DELETE_SUPPLIER_TYPE",
  ({ payload, id }: SagaActionParams<Type.SupplierTypeDto>) => ({
    payload,
    url: "/api/admin/suppliertypes/" + id,
  })
);

const supplierTypesSaga = [
  takeLatest<any>(
    getSupplierTypeListSaga.toString(),
    (payload: SagaGenericParams<Type.SupplierTypeDto[]>) =>
      getSaga<Type.SupplierTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getSupplierTypeDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.SupplierTypeDetailDto>) =>
      getSaga<Type.SupplierTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    createSupplierTypeSaga.toString(),
    (payload: SagaGenericParams<Type.SupplierTypeDto>) =>
      postSaga<Type.SupplierTypeDto>(payload)
  ),
  takeLatest<any>(
    updateSupplierTypeSaga.toString(),
    (payload: SagaGenericParams<Type.SupplierTypeDto>) =>
      putSaga<Type.SupplierTypeDto>(payload)
  ),
  takeLatest<any>(
    deleteSupplierTypeSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.SupplierTypeDto>(payload)
  ),
];

export default supplierTypesSaga;
